

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { DesignationSetup } from "../../components/DesignationSetup/DesignationSetup";


export const DesignationSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Designation Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Designation", navigateTo: "/company/designation/list" },
        { text: "Create Designation", navigateTo: "/company/designation/setup" }
      ]}
      mainContents={<DesignationSetup />}
    />
  );
};
